// src/team/components/cardDesignTemplates/index.js
import TeamCardDesign5 from './TeamCardDesign5';
import TeamCardDesign5WithFloatingButton from './TeamCardDesign5WithFloatingButton';

export const TEAM_CARD_DESIGNS = {
    design5: {
        id: 'design5',
        name: 'Classic Card',
        component: TeamCardDesign5
    },
    design5FloatingButton: {
        id: 'design5FloatingButton',
        name: 'Classic Card with Floating Buttons',
        component: TeamCardDesign5WithFloatingButton
    }
    // Add more team designs here in the future
};

// Helper function to get a team design component
export const getTeamDesignComponent = (designName = 'design5') => {
    return TEAM_CARD_DESIGNS[designName]?.component || TeamCardDesign5;
};

// Utility function for consistent image positioning
export const getImagePositioningProps = (layout, isCompanyLogo = false) => {
    const baseProps = {
        containerStyle: {
            position: 'absolute',
            bottom: 0,
            zIndex: 1000,
        },
        avatarStyle: {
            backgroundColor: '#ffffff',
            border: '8px solid #ffffff',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
        }
    };

    switch (layout) {
        case 'center-aligned':
            return {
                ...baseProps,
                containerStyle: {
                    ...baseProps.containerStyle,
                    left: '50%',
                    transform: 'translateX(-50%) translateY(50%)',
                },
                logoStyle: isCompanyLogo ? {
                    position: 'absolute',
                    bottom: '0px',
                    right: isCompanyLogo ? '-80px' : undefined,
                } : {}
            };
        case 'left-aligned':
        case 'portrait':
            return {
                ...baseProps,
                containerStyle: {
                    ...baseProps.containerStyle,
                    left: '23px',
                    transform: 'translateY(50%)',
                },
                logoStyle: isCompanyLogo ? {
                    position: 'absolute',
                    bottom: '0px',
                    right: isCompanyLogo ? '-30px' : undefined,
                } : {}
            };
        default:
            return baseProps;
    }
};